import { useCallback, useEffect, useState } from 'react';

interface UseAsyncDataResult<T> {
  data: T;
  isLoading: boolean;
  error: string | null;
  setData: React.Dispatch<React.SetStateAction<T>>;
  reload: () => void;
}

// Carrega dados de um *Service.ts (hoje mockado, amanhã uma chamada de API real) e
// expõe loading/error, além de setData para os hooks continuarem atualizando o
// estado localmente após as ações do usuário (confirmar, cancelar, etc.).
export function useAsyncData<T>(fetcher: () => Promise<T>, initialData: T, deps: unknown[] = []): UseAsyncDataResult<T> {
  const [data, setData] = useState<T>(initialData);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);

    fetcher()
      .then((result) => {
        if (active) setData(result);
      })
      .catch((err) => {
        if (active) setError(err instanceof Error ? err.message : 'Não foi possível carregar os dados.');
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadToken, ...deps]);

  const reload = useCallback(() => setReloadToken((token) => token + 1), []);

  return { data, isLoading, error, setData, reload };
}
